import React, { useEffect, useState, useRef } from 'react'
import Select from 'react-select';
import DatePickerCalendar from '../dashboard/calendars/DatePickerCalendar';
import Constants from '../../Constants';
import { dateFormat } from '../../services/Util'
import { calenderIcon } from '../../AppIcons';
import $ from "jquery";

export const DateTimeSelect = ({todayDate, dateValue, timeValue, timeOptions, onDateChange}) => {

  const refToggle = useRef(null);
  const refCalendar = useRef(null);
  const [toggle, toggleCal] = useState(false);
  const [date, setDate] = useState(dateValue);
  const [time, setTime] = useState((timeValue?timeValue:-1));
  const [hours, setHours] = useState(timeOptions);

  const setCalendarTime = (event) => {
    let newTime = event ? event.value :-1;
    setTime(newTime);
    if(onDateChange){
        onDateChange(date, newTime);
    }
  }

  const setCalendarDate = (event) => {
    let selectedDate = event ? new Date(event) : todayDate;
    let newTime = time;
    if(selectedDate.getTime() === todayDate.getTime()){
        let currentHour = todayDate.getHours();
        let newHours = hours.map(hour => {
            if (hour && hour.value <= currentHour) {
                hour.isdisabled = true;
            }
            return hour;
        });
        setHours(newHours);
        let nextHour = currentHour+1;
        selectedDate.setHours(nextHour)
        if(time < nextHour){
            newTime = nextHour;
        }
    }else if(selectedDate.getTime() > todayDate.getTime()){
        let newHours = hours.map(hour => {
            hour.isdisabled = (hour.value === -1) ? true : false;
            return hour;
        });
        setHours(newHours);
        if(time === -1){
            newTime = 0;
        }
    }

    setDate(selectedDate);
    setTime(newTime);
    toggleCal(false);
    if(onDateChange){
        onDateChange(selectedDate, newTime);
    }
  }

  const showCalendarDate = () => {
    toggle ? toggleCal(false) : toggleCal(true);
    if (toggle) {
      var requiredElement = document.querySelector(".dateTimeCalendar")
      if(requiredElement !== null) {
        requiredElement.focus();
      }
    }
  }

  const closeCalendar = (e) => {
    if (e.code === Constants.ESCAPE) {
        toggleCal(false);
    }
  }

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      color: state.isdisabled ? 'gray' : 'black', // Change color of disabled options
      cursor: state.isDisabled ? 'not-allowed' : 'default', // Change cursor style for disabled options
      // Add more custom styling properties as needed
    }),
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        refCalendar.current &&
        !refCalendar.current?.contains(event.target) &&
        !refToggle.current?.contains(event.target)
      ) {
        toggleCal(false);
      }
   }

    document.addEventListener("click", handleClickOutside, true);

    $.each($('.react-calendar__tile'), function( index, value ) {
        $(value).attr('aria-label', value.children[0].ariaLabel);
    });

    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [refCalendar]);

  useEffect(() => { setTime(timeValue) }, [timeValue]);
  useEffect(() => { setDate(dateValue) }, [dateValue]);
  useEffect(() => { setHours(timeOptions) }, [timeOptions]);
return (
         <>
            <div className="global-dropdown-select">
              <button
                onClick={(e) => {
                  showCalendarDate(e);
                }}
                ref={refToggle}
                className="drop-down-btn gb-dropBtn" 
                aria-label={date ? `${dateFormat(date, Constants.DATE_IN_WORDS)} selected` : "Select date"}>
                <span>{date ? dateFormat(date, Constants.DATE_IN_WORDS) : "Select date"}</span>
                {calenderIcon}
              </button>
            </div>
            {toggle ? (
            <div ref={refCalendar}
              onKeyDown={(e) => {
                closeCalendar(e);
              }}>
              <DatePickerCalendar 
              minDate={todayDate}
              className="dateTimeCalendar"
              value={date ? new Date(date):todayDate}
              selectDate={setCalendarDate} 
              />
              
            </div>
            ) : (
              ""
            )}
            <div className="global-dropdown-select small-dropdown-select">
                <Select className="" classNamePrefix='cw'
                  value={hours.filter(function (option) {
                    return option?.value === time;
                  })}
                  aria-label="What Time?"
                  onChange={event => setCalendarTime(event)}
                  options={hours}
                  menuShouldScrollIntoView={false}
                  isOptionDisabled={(option) => option.isdisabled}
                  styles={customStyles}
                />
            </div>
          </>
);
}